import { Loader } from '@/components/Loader';
import { useLeaderboardSnapshots } from '@/sections/customerManagement/hooks/data/useLeaderboardSnapshots';
import { useLeaderboardWeights } from '@/sections/customerManagement/hooks/data/useLeaderboardWeights';

import { LeaderboardTable } from './LeaderboardTable';
import { WeightsSummary } from './WeightsSummary';

function formatSeasonDates(start: string, end: string): string {
  const fmt = (d: Date) =>
    d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'UTC',
    });
  const startDate = new Date(start);
  const endDate = new Date(end);
  endDate.setUTCDate(endDate.getUTCDate() - 1);
  return `${fmt(startDate)} – ${fmt(endDate)}`;
}

export function ScoreBoard() {
  const { entries, activeMetrics, season, status } = useLeaderboardSnapshots();
  const { weights } = useLeaderboardWeights();

  if (status === 'pending') {
    return (
      <div className="flex h-full items-center justify-center py-12">
        <Loader isLoading type="spinner" />
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="flex h-full items-center justify-center py-12">
        <p className="text-chariot-text-secondary text-sm">
          Failed to load leaderboard data.
        </p>
      </div>
    );
  }

  if (entries.length === 0) {
    return (
      <div className="flex h-full items-center justify-center py-12">
        <p className="text-chariot-text-secondary text-sm">
          No leaderboard data available.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {season && (
        <div className="flex items-baseline gap-3">
          <h2 className="text-lg font-semibold">
            <span
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  season.half === 1
                    ? 'linear-gradient(to right, #7eb8da, #e8913a, #c9402c)'
                    : 'linear-gradient(to right, #c9402c, #e8913a, #7eb8da)',
              }}
            >
              {season.name}
            </span>{' '}
            <span className="text-chariot-text-primary">{season.year}</span>
          </h2>
          <span className="text-chariot-text-secondary text-sm">
            {formatSeasonDates(season.start, season.end)}
          </span>
        </div>
      )}
      {weights && <WeightsSummary weights={weights} />}
      <LeaderboardTable
        entries={entries.filter(e => e.rank !== null)}
        activeMetrics={activeMetrics}
      />
    </div>
  );
}
